module.exports = __webpack_public_path__ + "static/img/dkzj.9ea61d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/dkzj.jpg
// module id = E9Zn
// module chunks = 0